
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        modelValue: {
            type: Boolean,
            default: false,
        },
        zIndex: {
            type: Number,
            default: 500
        }
    },
    emits: ['update:modelValue', 'close'],
    setup(props, { emit }) {
        const onClose = () => {
            if (props.disabled) return

            emit('update:modelValue', !props.modelValue)
            emit('close')
        }

        return {
            onClose
        }
    }
})
